/* eslint linebreak-style: ["error", "windows"] */

const menuItem = document.getElementsByClassName('js-menuToggle');
const dropdownToggle = document.getElementsByClassName('dropdown-toggle');
const menuDropdowns = document.getElementsByClassName('dropdown-content');
const modal = document.getElementById('js-modal');
let timeoutObj;

function expandMenu() {
    this.classList.add('is-active');
    modal.classList.add('is-active');
}

function contractMenu() {
    console.log("here");
    const obj = this;
    timeoutObj = setTimeout(() => {
        obj.classList.remove('is-active');
        modal.classList.remove('is-active');
    }, 300);
}

function contractMenuNoDelay() {
    const obj = document.getElementsByClassName('js-menuToggle');

    Array.from(obj).forEach((el) => {
        el.classList.remove('is-active');
    });
}

function clearTimeoutObj() {
    //clearTimeout(timeoutObj);
}

const MainMenu = {
    init() {
        Array.from(menuItem).forEach((el) => {
            el.addEventListener('click', expandMenu);
            el.addEventListener('mouseleave', contractMenu);
        });
        Array.from(dropdownToggle).forEach((el) => {
            el.addEventListener('click', contractMenu);
        });
        Array.from(menuDropdowns).forEach((el) => {
            el.addEventListener('mouseover', clearTimeoutObj);
        });
    },
};

export default MainMenu;
